import React, { useState } from 'react';

const SupportTab: React.FC = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        question: '',
    });

    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Здесь можно подключить отправку через fetch/axios
        console.log('Отправлено:', formData);
        setSubmitted(true);
    };

    return (
        <div className="profile-page profile-page_support">
            <div className="profile-page__inner">
                <div className="profile-page__content-wrapper">
                    <header className="profile-page__header">
                        <h1 className="title profile-page__title">Тех. поддержка</h1>
                        <p className="profile-page__description">
                            Если у вас есть вопросы по работе сервиса или предложения, заполните форму и отправьте нам.
                            Срок рассмотрения вопроса составляет 24 часа. Ответ придет на ваш email.
                        </p>
                    </header>

                    <div className="profile-page__content">
                        {!submitted ? (
                            <form className="form profile-page__form bionmax_account_support_form" onSubmit={handleSubmit}>
                                <fieldset className="auth-form__hint error">
                                    <span className="auth-form__hint-text"></span>
                                </fieldset>

                                <fieldset className="form__fields">
                                    <div className="form__row">
                                        <div className="input">
                                            <label htmlFor="name" className="input__label input-label">Имя</label>
                                            <label className="text-input">
                                                <input
                                                    id="name"
                                                    name="name"
                                                    className="text-input__input"
                                                    placeholder="Мария"
                                                    type="text"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </label>
                                            <small className="input_error"></small>
                                        </div>
                                    </div>

                                    <div className="form__row">
                                        <div className="input">
                                            <label htmlFor="email" className="input__label input-label">E-Mail</label>
                                            <label className="text-input">
                                                <input
                                                    id="email"
                                                    name="email"
                                                    className="text-input__input"
                                                    placeholder="example@gmail.com"
                                                    type="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </label>
                                            <small className="input_error"></small>
                                        </div>
                                    </div>

                                    <div className="form__row">
                                        <div className="input">
                                            <label htmlFor="question" className="input__label input-label">Вопрос</label>
                                            <label className="text-input">
                                                <textarea
                                                    id="question"
                                                    name="question"
                                                    className="text-input__input"
                                                    rows={3}
                                                    value={formData.question}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </label>
                                            <small className="input_error"></small>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="form__submit">
                                    <button className="button button_outline" type="submit">Отправить</button>
                                </fieldset>
                            </form>
                        ) : (
                            <div className="support-success-message">
                                <p>Спасибо! Ваш вопрос отправлен. Мы ответим на него в течение 24 часов.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SupportTab;
